export default class Distribution {
    constructor(
        public readonly name: string,
        public readonly percentage: number,
        public readonly quantity: number
    ) { }
}